import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import ClientHoldingTable from "../../../Components/ReportTables/ClientHoldingTable";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import { toast } from "react-toastify";
import { Partner_Reports } from "../../../Configuration/Partner_URL";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function ClientHoldingNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");
  const [fileType, setFileType] = useState("grid");
  const [data, setData] = useState(null);
  const [onDate, setOnDate] = useState(moment().format("MM-DD-YYYY"));
  const [loader, setLoader] = useState(false);
  const [smallLoader, setSmallLoader] = useState({
    excel: false,
    pdf: false,
    mail: false,
  });
  const [error, setError] = useState("");
  const [seg, setSeg] = useState("stocks");
  const [noReportFound, setNoReportFound] = useState(false);

  const clientCode = localStorage.getItem("clientCode");
  const ClientId2 = localStorage.getItem("ClientId2");

  const getClientHoldingReport = async () => {
    setLoader(fileType === "grid");
    setSmallLoader({
      excel: fileType === "excel",
      pdf: fileType === "pdf",
      mail: fileType === "mail",
    });

    const payloadValue = { clientCode: clientCode || ClientId2, date: onDate, fileType, seg };
    console.log(payloadValue, "payloadValue");
    const encPayload = AESEncryption(payloadValue);
    try {
      const { data: response } = await axiosInstance.post(
          Dashboard_Client_Report.ClientHoldingReport_URL,
        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(response);
      if (res?.data) {
        setNoReportFound(false);
        if (fileType === "grid") {
          setData(res?.data);
        } 

        else if (fileType === "excel") {
                  window.open(res?.data, "_self", "noopener,noreferrer");
                } else if (fileType === "pdf") {
                  window.open(res?.data, "_blank", "noopener,noreferrer");
                } else if (fileType === "mail") {
                  toast.success("Mail sent successfully");
                }
        // else {

        //   window.open(
        //     res?.data,
        //     fileType === "pdf" ? "_blank" : "_self",
        //     "noopener,noreferrer"
        //   );
        // }
        // if (fileType === "mail") {
        //   toast.success("Mail sent successfully");
        // }
      } else {
        if (fileType !== "grid") {
          toast.error(res.message);
        } else {
          setData([]);
          setNoReportFound(res.message);
        }
      }
    } catch (error) {
      if (fileType !== "grid") {
        toast.error(error.message);
      } else {
        setData([]);
        setNoReportFound(error.message);
      }
    } finally {
      setLoader(false);
      setSmallLoader({ excel: false, pdf: false, mail: false });
    }
  };

  const handleOnDateChange = (e) => {
    const formattedDate = moment(e.target.value).format("MM-DD-YYYY");
    setOnDate(formattedDate);
    resetState();
  };

  const resetState = () => {
    setData(null);
    setError("");
    setFileType("");
    setNoReportFound(false);
  };

  const handleSegmentChange = (e) => {
    setSeg(e.target.value);
    resetState();
  };

  useEffect(() => {
    if (fileType && (clientCode !== null || ClientId2 !== null) ) {
      getClientHoldingReport();
    }
  }, [fileType, (clientCode || ClientId2)]);

  const handleOnClick = (e) => {
    if (onDate && seg) {
      const selectedFileType = e.target.value;
      if (compareDate(onDate)) {
        setFileType(selectedFileType);
        setError("");
      } else {
        setError("Please Select Correct Date.");
      }
    }
  };

  const currentDate = moment().format("DD/MM/YYYY");
  const DateReverse = moment(currentDate, "DD/MM/YYYY").format("YYYY-MM-DD");

  console.log(data, "data88999");
  return (
    <div
      className="tab-pane fade show active"
      id="client-holding"
      role="tabpanel"
      aria-labelledby="client-holding"
    >
      <div className="reports-date-filter">
        <div className="reports-left-form">
          <form>
            <div className="report-form-wrapper">
              <div className="form-group">
                <label className="form-label" htmlFor="to">
                  {Constants.As_On_Date}
                </label>
                <input
                  type="date"
                  max={DateReverse}
                  defaultValue={moment(onDate, "MM-DD-YYYY").format(
                    "YYYY-MM-DD"
                  )}
                  className="OnDate"
                  onChange={handleOnDateChange}
                />
                <span className="date-error">{error}</span>
              </div>
              <div className="form-group">
                <label className="form-label">{Constants.Type}</label>
                <select
                  className="report-custom-select"
                  onChange={handleSegmentChange}
                >
                  <option value="stocks">Equity Holding</option>
                  <option value="mf">MF Holding</option>
                </select>
              </div>
            </div>
          </form>
          <button
            className="generate-button get-data"
            value="grid"
            onClick={handleOnClick}
          >
            {Constants.Submit}
          </button>
        </div>
        <div className="report-btn-wrapper">
          <button
            className="generate-button mail-btn"
            value="mail"
            onClick={handleOnClick}
          >
            {smallLoader.mail ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-email"></span> E-Mail
              </>
            )}
          </button>
          <button
            className="generate-button excel-btn"
            value="excel"
            onClick={handleOnClick}
          >
            {smallLoader.excel ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-excelsvg"></span> {Constants.Excel}
              </>
            )}
          </button>
          <button
            className="generate-button pdf-btn"
            value="pdf"
            onClick={handleOnClick}
          >
            {smallLoader.pdf ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-pdfsvg"></span> {Constants.PDF}
              </>
            )}
          </button>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : data && data.length > 0 ? (
        <ClientHoldingTable data={data} seg={seg} />
      ) : (
        noReportFound && (
          <h4 className="report-error-message">{noDataFound(noReportFound)}</h4>
        )
      )}
    </div>
  );
}

export default ClientHoldingNew;
